module.exports = __webpack_public_path__ + "img/back-icon.ef1a4e4a.svg";